/**
 * 動画取得API
 */
import { Component, Vue } from 'vue-property-decorator'
import { ApiResponseMovie } from '@/models/apiResponses/movie'

@Component
export default class MovieApi extends Vue {
  /**
   * AWS S3署名付き動画URL取得
   * @returns AWS S3署名付き動画URL
   */
  protected async getMovieUrl(): Promise<ApiResponseMovie> {
    const { data }: { data: ApiResponseMovie } = await Vue.prototype.$http.httpWithToken.get(`/v2/guide_movie`)

    return data
  }
}
